import getPaginatedReports from './get-paginated-reports';

const extraReducers = {
  getPaginatedReports,
};

export default extraReducers;
